import { Endpoints } from '@/api';
import { useInfiniteEntitiesAndGroups } from '@/models/entity';
import useDebouncedState from '@/utils/useDebouncedState';

const ENTITIES_PER_PAGE = 20;

export const useEntityFilterState = ({
  traits,
}: {
  traits?: Endpoints['GET /entities-and-groups']['query']['traits'];
}) => {
  const [search, debouncedSearch, setSearch] = useDebouncedState<string>('', 300);

  // The first hook is to get the total count of options without search filter
  // React-query will only fetch once, even with two hooks (as long as the params are the same)
  const { data: initialData } = useInfiniteEntitiesAndGroups({
    traits,
    limit: ENTITIES_PER_PAGE,
  });
  const { data, fetchNextPage, isLoading } = useInfiniteEntitiesAndGroups({
    traits,
    limit: ENTITIES_PER_PAGE,
    search: debouncedSearch || undefined,
  });

  const entityGroups = data?.pages.flatMap((page) => page.entityGroups) ?? [];
  const entities = data?.pages.flatMap((page) => page.entities) ?? [];
  const count = initialData?.pages[0]?.meta.count || 0;

  return {
    search,
    setSearch,
    fetchNextPage,
    isLoading,
    entityGroups,
    entities,
    count,
  };
};
